import { render, staticRenderFns } from "./permission-top-steps.vue?vue&type=template&id=df7a027a&scoped=true"
import script from "./permission-top-steps.vue?vue&type=script&lang=js"
export * from "./permission-top-steps.vue?vue&type=script&lang=js"
import style0 from "./permission-top-steps.vue?vue&type=style&index=0&id=df7a027a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7a027a",
  null
  
)

export default component.exports